module.exports = __webpack_public_path__ + "static/media/emoji.24984d79.png";